// Centralized SVG attribute mapping for React

export const SVG_ATTR_MAP = {
  'stroke-width': 'strokeWidth',
  'stroke-linecap': 'strokeLinecap',
  'stroke-linejoin': 'strokeLinejoin',
  'stroke-miterlimit': 'strokeMiterlimit',
  'fill-rule': 'fillRule',
  'clip-path': 'clipPath',
  'xlink:href': 'xlinkHref',
  'xmlns:xlink': 'xmlnsXlink',
  'stop-color': 'stopColor',
  'font-size': 'fontSize',
  // Add more as needed
};

export function mapSvgAttributes(attributes) {
  if (!attributes) return {};
  
  // Convert attributes object to React-compatible format
  return Object.entries(attributes).reduce((acc, [key, value]) => {
    // Convert class to className for React
    if (key === 'class') {
      acc.className = value;
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
} 